<template>
  <div>
    <v-card
      height="100%"
      width="100%"
    >
      <v-card-title>
        <v-col
          cols="12"
          sm="2"
          >{{$t('ContentCreator.ContentCreator')}}</v-col
        >
        <v-col
          cols="12"
          sm="3"
          class="right text-right"
        >
        </v-col>
      </v-card-title>

      <div id="gjs"></div>
    </v-card>
  </div>
</template>
  
  <script>
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs/dist/grapes.min.js';
// import 'grapesjs-preset-webpage/dist/grapesjs-preset-webpage.min.css'
// import 'grapesjs-preset-webpage/dist/grapesjs-preset-webpage.min.js'
import { mapState } from 'vuex';
//import AddContentCategory from '@/views/contentLibrary/AddContentCategory';
import { serializer } from '../../api/shared/serializer';
import moment from 'moment';
//import Loader from '@/components/loader/Loader.vue';
import plugin from 'grapesjs-preset-webpage';
import basicblocks from 'grapesjs-blocks-basic';

export default {
  name: 'ContentCreatorEditor',
  components: {}, //AddContentCategory, Loader
  data() {
    return {
      loading: false,
      filters: {
        category: '',
      },
      addCategoryDialog: false,
    };
  },

  mounted() {
    grapesjs.init({
      container: '#gjs',
      height: '900px',
      width: '100%',
      storageManager: {
        id: 'gjs-',
        type: 'local',
        autosave: true,
        storeComponents: true,
        storeStyles: true,
        storeHtml: true,
        storeCss: true,
      },
      deviceManager: {
        devices: [
          {
            id: 'desktop',
            name: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Desktop'],
            width: '',
          },
          {
            id: 'tablet',
            name: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.ResidentDevice'],
            width: '768px',
            widthMedia: '992px',
          },
          {
            id: 'mobilePortrait',
            name: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.MobilePortrait'],
            width: '320px',
            widthMedia: '575px',
          },
        ],
      },
      plugins: [basicblocks],
      pluginsOpts: {
        [basicblocks]: {
          /* options */
        },
      },
    });
  },

  computed: {
    ...mapState({
      facility: state => state.facilityModule.selectedFacility,
      categories: state => state.contentLibraryModule.contentCategories,
      contentItems: state =>
        serializer.transformFields(state.contentLibraryModule.contentItems, {
          isEnabled: isEnabled => (isEnabled ? 'Enabled' : 'Disabled'),
          dateTimeUpdated: date =>
            date
              ? moment(date.seconds * 1000).format(
                  state.facilityModule.selectedFacility.dateFormat
                )
              : '',
          description: description =>
            description && description.length > 40
              ? description.substring(0, 40) + '...'
              : description,
        }),
    }),
  },

  created() {
    this.loading = true;
    // this.$store.dispatch('getContentPage' + this.$route.params.id.toString());
    // this.pagePer = this.$route.params.pagePer;
    // this.page = this.$route.params.page;
  },

  watch: {
    contentItems(items) {
      this.loading = false;
    },
  },

  methods: {
    handleClickContentItem(row) {
      this.$router.push({
        name: `ContentCreatorEditor`,
        params: {
          id: row.id,
          page: this.page,
          pagePer: this.pagePer,
        },
      });
    },
    navigateToCreator() {
      this.$router.push('/contentLibrary/');
    },
    updatePage(page) {
      this.page = page;
    },
    updatePerPage(pagePer) {
      this.pagePer = pagePer;
    },
  },
};
</script>
  
  <style scoped>
.content-img {
  width: 60px;
  border-radius: 0px;
}

::v-deep tr {
  height: 80px !important;
}
</style>
  